import React from "react";
import "./post.scss";

const Post = (props) => {
  console.log(props.post);
  return (
    <div className="mainBlog">
      <img src={props.post.picture} alt="" />

      <div className="details">
        <h3>{props.post.title}</h3>
        <span className="Author">{props.post.username}</span>
      </div>
    </div>
  );
};

export default Post;
